module.exports = __webpack_public_path__ + "img/af.fd81c9e1.svg";